import { useState, useEffect } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { API_URL } from '../config/api'
import './Checkout.css'

export default function Checkout() {
  const { orderId } = useParams()
  const { token } = useAuth()
  const navigate = useNavigate()

  const [order, setOrder] = useState(null)
  const [loading, setLoading] = useState(true)
  const [paying, setPaying] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!orderId || !token) return
    fetch(`${API_URL}/api/orders/${orderId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => {
        if (!r.ok) throw new Error('Bestelling niet gevonden')
        return r.json()
      })
      .then(d => setOrder(d.data))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false))
  }, [orderId, token])

  const handlePay = async () => {
    setPaying(true)
    setError(null)
    try {
      const res = await fetch(`${API_URL}/api/orders/create-mollie-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ orderId: parseInt(orderId) }),
      })
      if (!res.ok) {
        const err = await res.json()
        throw new Error(err.error || 'Betaling starten mislukt')
      }
      const { checkoutUrl } = await res.json()
      window.location.href = checkoutUrl
    } catch (err) {
      setError(err.message)
      setPaying(false)
    }
  }

  if (loading) return (
    <div className="checkout-page">
      <div className="checkout-spinner"><div className="spinner" /></div>
    </div>
  )

  if (error && !order) return (
    <div className="checkout-page">
      <div className="checkout-card checkout-error">
        <h2>Oeps!</h2>
        <p>{error}</p>
        <Link to="/shop" className="btn-back">← Terug naar winkel</Link>
      </div>
    </div>
  )

  const attr = order?.attributes || {}
  let items = []
  try { items = JSON.parse(attr.items || '[]') } catch {}
  const total = (attr.orderTotal || 0) / 100

  return (
    <div className="checkout-page">
      <div className="checkout-card">
        <div className="checkout-header">
          <h1>Bestelling bevestigen</h1>
          <span className="order-id">#{order?.id}</span>
        </div>

        <div className="checkout-customer">
          <div><span>Naam</span><strong>{attr.customer_name}</strong></div>
          <div><span>E-mail</span><strong>{attr.customer_email}</strong></div>
        </div>

        <div className="checkout-items">
          <h2>Artikelen</h2>
          <table>
            <thead>
              <tr><th>Product</th><th>Aantal</th><th>Prijs</th></tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={i}>
                  <td>{item.name}</td>
                  <td>{item.quantity ?? 1}</td>
                  <td>€{((item.price || 0) * (item.quantity ?? 1)).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="checkout-total">
          <span>Totaal</span>
          <strong>€{total.toFixed(2)}</strong>
        </div>

        {error && <p className="checkout-err">{error}</p>}

        <div className="checkout-actions">
          <button className="btn-pay" onClick={handlePay} disabled={paying}>
            {paying ? <><span className="btn-spinner" /> Doorsturen...</> : '🔒 Betalen via Mollie'}
          </button>
          <Link to="/shop" className="btn-cancel">Annuleren</Link>
        </div>

        <p className="checkout-secure">
          🔒 Veilig betalen via <strong>Mollie</strong> — iDEAL, Bancontact, Visa, Mastercard
        </p>
      </div>
    </div>
  )
}
